/* eslint-disable @typescript-eslint/no-explicit-any */
import type { APIResponse } from '../services/api.service';

declare global {
  interface Window {
    dataLayer: any[];
    CCF: CCFGlobals;
    APP_STAT: number;
    API_PRELOAD?: APIResponse;
    gtag: (...args: any[]) => void;
    reportError: (error: Error | string, comment?: string, silent?: boolean) => void;
    _pendingErrors: Array<[error: Error | string, comment?: string, silent?: boolean]>;
    html2canvas(target: HTMLElement, options?: any): Promise<HTMLCanvasElement>;
    DD_RUM: any;
    DD_LOGS: any;
    isDev?: boolean;
  }

  interface Worker {
    CCF: CCFGlobals;
  }

  interface NavigatorConnection {
    readonly downlink?: number;
    readonly effectiveType?: 'slow-2g' | '2g' | '3g' | '4g';
    readonly rtt?: number;
    readonly saveData?: boolean;
  }

  interface Navigator {
    readonly clipboard: Clipboard;

    readonly connection?: NavigatorConnection;
  }
}

if (!self.CCF) {
  self.CCF = {};
}

export interface CCFGlobals {
  supportsPassiveListeners?: boolean;
  scrollTo?: number;
  LOADED?: boolean;
}
